module.exports = __webpack_public_path__ + "img/goods6_2.115eb7bd.jpg";